<template>
  <VChart class="graph" :option="option" autoresize />
</template>
<script>
import { defineComponent, ref, provide } from "vue";
import { useMyStorage } from "@/store/global";
import { use } from "echarts/core";
import { SVGRenderer, CanvasRenderer } from "echarts/renderers";
import {
  BarChart,
  LineChart,
  LinesChart,
  PieChart,
  MapChart,
  RadarChart,
  ScatterChart,
  EffectScatterChart,
} from "echarts/charts";
import {
  GridComponent,
  PolarComponent,
  GeoComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  ToolboxComponent,
  DataZoomComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import axios from "axios";
export default defineComponent({
  props: {
    Ticker: {
      type: String,
      requred: true,
    },
  },
  name: "GraphInfo",
  components: {
    VChart,
  },
  setup(props) {
    const store = useMyStorage();
    use([
      BarChart,
      LineChart,
      PieChart,
      MapChart,
      RadarChart,
      ScatterChart,
      EffectScatterChart,
      LinesChart,
      GridComponent,
      PolarComponent,
      GeoComponent,
      TooltipComponent,
      LegendComponent,
      TitleComponent,
      VisualMapComponent,
      DatasetComponent,
      CanvasRenderer,
      SVGRenderer,
      ToolboxComponent,
      DataZoomComponent,
    ]);
    provide(THEME_KEY, "dark");
    /*const random = () => {
      return Math.round(300 + Math.random() * 700) / 10;
    };*/
    let data = {
      categoryData: [],
      values: [],
      volumes: [],
    };
    const option = ref({
      xAxis: {
        type: "category",
        // data: data.categoryData,
        data: [],
        boundaryGap: false,
        axisLine: { onZero: false },
        splitLine: { show: false },
        min: "dataMin",
        max: "dataMax",
        axisPointer: {
          z: 100,
        },
      },
      yAxis: {
        scale: true,
        splitArea: {
          show: true,
        },
        position: "right",
      },
      series: [
        {
          //  data: data.values,
          data: [],
          type: "line",
        },
      ],
    });
    //console.log(props.Ticker);
    const getStringDate = (dt) => {
      return new Date(dt).toISOString().slice(0, 10).replace("T", " ");
    };
    const splitData = (rawData) => {
      /*[24187.0,24187.0,24142.0,24144.0,7.0,1660143000]*/

      let categoryData = [];

      let values = [];
      let volumes = [];

      for (let i = 0; i < rawData.length; i++) {
        let dt = +rawData[i].splice(5, 1)[0];
        categoryData.unshift(getStringDate(dt * 1000));
        let v = rawData[i][3];
        values.unshift(v);
        let vl = rawData[i][4];
        volumes.unshift(vl);
      }
      return {
        categoryData: categoryData,
        values: values,
        volumes: volumes,
      };
    };
    const LoadGraphInfo = (ticker) => {
      const url = store.ServerUrl + "/users/instrument/history";
      axios
        .post(url, { Ticker: ticker, Size: "840" })
        .then(function (response) {
         // console.log(response);
          const res = JSON.parse(response.data.Bars);
          data = splitData(res.data);
          const optnew = {
            xAxis: {
              type: "category",
               data: data.categoryData,
             // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
              boundaryGap: false,
              axisLine: { onZero: false },
              splitLine: { show: false },
              min: "dataMin",
              max: "dataMax",
              axisPointer: {
                z: 100,
              },
            },
            yAxis: {
              scale: true,
              splitArea: {
                show: true,
              },
              position: "right",
            },
            series: [
              {
                  data: data.values,
              //  data: [150, 230, 224, 218, 135, 147, 260],
                type: "line",
              },
            ],
          };
            option.value = optnew;
          //console.log(data);
        });
    };
    LoadGraphInfo(props.Ticker);
    return { option };
  },
});
</script>
